// Define types for train properties
export interface TrainProperties {
  crewHoursOfService: string;
  performanceClassification: string;
  reportedLengthClassification: string;
  trainStopped: boolean;
  stoppedTimeInMinutes?: number;
  lorCrewHosInd: string;
  [key: string]: any;
}

// Map train styling and configuration utilities
export const determineTrainColors = (props: TrainProperties) => {
  const firstPartColor =
    props.crewHoursOfService === 'HOURS_OF_SERVICE_MORE_THAN_4_FILTER'
      ? '#b3cdfb'
      : props.crewHoursOfService === 'HOURS_OF_SERVICE_LESS_THAN_EQUAL_TO_4'
      ? '#e33a31'
      : '#ffffff';

  // Determine middle part color based on performance classification
  const middlePartColor =
    props.performanceClassification === 'PERFORMANCE_CLASSIFICATION_LATE'
      ? '#e33a31' //red
      : props.performanceClassification === 'PERFORMANCE_CLASSIFICATION_EARLY'
      ? '#2F6EF7' //blue
      : props.performanceClassification === 'PERFORMANCE_CLASSIFICATION_DELAYED'
      ? '#ffbd33' //yellow
      : props.performanceClassification ===
        'PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME'
      ? '#15c154' //green
      : '#ffffff';

  return { firstPartColor, middlePartColor };
};

export const determineTrainIcon = (props: TrainProperties): string => {
  const { trainStopped,stoppedTimeInMinutes, lorCrewHosInd } = props;

  const stoppedIconMap: Record<string, string> = {
    R: 'blue-calendar-stopped-b-v1',
    C: 'blue-call-stopped-b-v1',
    NC: 'red-call-stopped-b-v1',
    NR: 'red-calendar-stopped-b-v1'
  };

  const movingIconMap: Record<string, string> = {
    R: 'blue-calendar-nb-v1',
    C: 'blue-call-nb-v1',
    NC: 'red-call-nb-v1',
    NR: 'red-calendar-nb-v1'
  };

  // Return the appropriate icon based on train status
  return (trainStopped && stoppedTimeInMinutes && stoppedTimeInMinutes > 120)
    ? stoppedIconMap[lorCrewHosInd] || 'stopped-b-v1'
    : movingIconMap[lorCrewHosInd] || 'backgrd-nb-v1';
};

export const determineTrainLightIcon = (props: TrainProperties): string => {
  const { trainStopped,stoppedTimeInMinutes, lorCrewHosInd } = props;

  const stoppedIconMap: Record<string, string> = {
    R: 'light-blue-calendar-stopped-b-v1',
    C: 'light-blue-call-stopped-b-v1',
    NC: 'light-red-call-stopped-b-v1',
    NR: 'light-red-calendar-stopped-b-v1'
  };

  const movingIconMap: Record<string, string> = {
    R: 'light-blue-calendar-nb-v1',
    C: 'light-blue-call-nb-v1',
    NC: 'light-red-call-nb-v1',
    NR: 'light-red-calendar-nb-v1'
  };

  // Return the appropriate icon based on train status
  return (trainStopped && stoppedTimeInMinutes && stoppedTimeInMinutes > 120)
    ? stoppedIconMap[lorCrewHosInd] || 'light-stopped-b-v1'
    : movingIconMap[lorCrewHosInd] || 'light-backgrd-nb-v1';
};
